// @flow

import React from 'react';
import styled from 'styled-components';

import times from 'lodash/times';

const Root = styled.svg`
  position: absolute;
  left: ${props => props.direction === 'right' ? '0' : 'auto'};
  right: ${props => props.direction === 'right' ? 'auto' : '0'};
  top: 0;

  transform: scaleX(${props => props.direction === 'right' ? 1 : -1});

  width: 30px;
`

type Props = {
  nodeCount: number,
  direction: string,
  color: string,
}

function Bracket({ nodeCount, color, direction }: Props) {
  return (
    <Root viewBox={`0 0 30 ${nodeCount * 30}`} direction={direction}>
      <line
        x1={0} y1={nodeCount % 2 === 0 ? (Math.floor(nodeCount / 2) * 30) - 15 : ((nodeCount / 2) * 30)}
        x2={10} y2={nodeCount % 2 === 0 ? (Math.floor(nodeCount / 2) * 30) - 15 : ((nodeCount / 2) * 30)}
        strokeWidth="1"
        stroke={color}
      />
      <line
        x1={10} y1={15}
        x2={10} y2={(nodeCount * 30) - 15}
        strokeWidth="1"
        stroke={color}
      />
      {times(nodeCount, index => (
        <g key={index}>
          <line
            x1={10} y1={((index + 1) * 30) - 15}
            x2={28} y2={((index + 1) * 30) - 15}
            strokeWidth="1"
            stroke={color}
          />
          <circle
            cx={28} cy={((index + 1) * 30) - 15} r={2}
            fill={color}
          />
        </g>
      ))}
    </Root>
  )
}

export default Bracket;



// WEBPACK FOOTER //
// ./src/components/CategoryNav/Bracket.js